import 'console-shim';
import root from 'window-or-global';
import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import ScrollToTop from './routes/ScrollToTop';
import {setLocale} from '@epic-core/common';
import App from './App';
import {clientInterceptors} from '@epic-core/axios-client';
import RefreshOnSessionChange from 'epic-react-common/src/components/RefreshOnSessionChange';
import {LocalizationContext} from '@epic-core/localization';
import axios from 'axios';
import pako from 'pako';

clientInterceptors();
axios.defaults.timeout = 15000; //newsletter can sometimes take longer than the default of 5000ms

const reactDomEle = root.document.getElementById('epicGamesReactWrapper');

// only proceed if the react ele exists
if (reactDomEle) {
    let loginStatus = null;
    const rawPreload = root.__epic_client_state;
    if (rawPreload && typeof rawPreload === 'string') {
        //decompress the model from a Uint8Array inside of a string
        const preload = pako.inflate(rawPreload.split(','), {to: 'string'});
        root.__epic_client_state = JSON.parse(preload);

        try {
            const epicGamesHeader = root.__epic_client_state.epicGamesHeader || {};
            loginStatus = epicGamesHeader.isLoggedIn;
        } catch (ex) {
            // no-op
        }

        setLocale(root.__locale);

        const i18nContext = Object.assign(
            {},
            {
                messages: root.__epic_client_state.messageProperties,
                supportedLocales: root.__epic_client_state.supportedLocales,
                locale: root.__epic_client_state.locale
            }
        );

        delete root.__epic_client_state.messageProperties;
        delete root.__epic_client_state.supportedLocales;

        ReactDOM.hydrate(
            <BrowserRouter>
                <RefreshOnSessionChange isLoggedIn={loginStatus}>
                    <LocalizationContext.Provider value={i18nContext}>
                        <ScrollToTop>
                            <App appState={root.__epic_client_state} />
                        </ScrollToTop>
                    </LocalizationContext.Provider>
                </RefreshOnSessionChange>
            </BrowserRouter>,
            reactDomEle
        );
    }
}
